import React, { ReactElement } from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import InlineCode from "../../components/inlineCode"
import { ValidatorFunction, CodeExample } from "../../components/validatorFuncs"
import Examples from "../../components/codeExamples"

function BooleanFunctions(): ReactElement {
  return (
    <Layout
      title="Boolean functions"
      description="Validation functions for use on booleans"
    >
      <h1>Boolean Functions</h1>
      <p>
        <ul className="list">
          {["True", "False"].map((func) => (
            <li>
              <Link to={`/functions/boolean/#${func}`}>{func}</Link>
            </li>
          ))}
        </ul>
      </p>
      <hr className="my-6" />
      <ValidatorFunction
        name="True"
        description="Ensures the boolean value being validated is true."
        methods={[`True()`, `True<T>(Expression<Func<T, bool>> selector)`]}
        brokenRule="Value must be true."
      >
        <CodeExample
          label="Using type instance."
          code={Examples.Boolean.True.Example1}
        />
        <CodeExample
          label="Using selector expression."
          code={Examples.Boolean.True.Example2}
        />
        <CodeExample
          label={
            <>
              Using <InlineCode>For</InlineCode> function.
            </>
          }
          code={Examples.Boolean.True.Example3}
        />
      </ValidatorFunction>
      <hr className="my-6" />
      <ValidatorFunction
        name="False"
        description="Ensures the boolean value being validated is false."
        methods={[`False()`, `False<T>(Expression<Func<T, bool>> selector)`]}
        brokenRule="Value must be false."
      >
        <CodeExample
          label="Using type instance."
          code={Examples.Boolean.False.Example1}
        />
        <CodeExample
          label="Using selector expression."
          code={Examples.Boolean.False.Example2}
        />
        <CodeExample
          label={
            <>
              Using <InlineCode>For</InlineCode> function.
            </>
          }
          code={Examples.Boolean.False.Example3}
        />
      </ValidatorFunction>
    </Layout>
  )
}

export default BooleanFunctions
